import { useContext, useState } from "react";
import { useApiCall } from "../custom-hooks/api-call";
import { GlobalContext } from "../context/Context";

export default function LoginPage() {

  const {state, dispatch} = useContext(GlobalContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("")

  const apiCall = useApiCall();

  const login = async(e) => {
    e.preventDefault();
    try {
      const apiRes = await apiCall({method: "post", url: "login", data: {
        "email": email,
        "password": password
      }})
      console.log("apiRes", apiRes)
      localStorage.setItem("userSaleHub", JSON.stringify(apiRes.user));
      localStorage.setItem("tokenSaleHub", apiRes.token);
      dispatch({ type: 'USER_LOGIN', payload: apiRes.user, token: apiRes.token });
    } catch (error) {
      console.log("Err", error)
    }
  }

  return (
    <div style={{
      width: "100vw", height: "100vh",
      background: "#080A12",
      display: "flex",
      overflow: "hidden",
      fontFamily: "'DM Sans', sans-serif",
      position: "relative",
    }}>

      <div style={{
        position: "absolute", inset: 0, zIndex: 1, pointerEvents: "none",
        background: `
          radial-gradient(ellipse at 28% 50%, rgba(79,110,247,0.16) 0%, transparent 60%),
          radial-gradient(ellipse at 78% 18%, rgba(123,92,240,0.11) 0%, transparent 50%),
          radial-gradient(ellipse at 60% 85%, rgba(79,110,247,0.06) 0%, transparent 40%)
        `,
      }} />

      <div style={{
        flex: "0 0 55%", position: "relative", zIndex: 5,
        display: "flex", flexDirection: "column", justifyContent: "space-between",
        padding: "44px 48px",
      }}>

        <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
            <defs>
              <linearGradient id="lgLogin" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
                <stop stopColor="#4F6EF7" />
                <stop offset="1" stopColor="#7B5CF0" />
              </linearGradient>
            </defs>
            <rect width="36" height="36" rx="8.5" fill="url(#lgLogin)" />
            <circle cx="18" cy="18" r="7" stroke="rgba(255,255,255,0.92)" strokeWidth="1.8" fill="none" />
            <circle cx="18" cy="18" r="2.8" fill="rgba(255,255,255,0.95)" />
            <line x1="18" y1="6" x2="18" y2="10.5" stroke="rgba(255,255,255,0.42)" strokeWidth="1.4" strokeLinecap="round" />
            <line x1="18" y1="25.5" x2="18" y2="30" stroke="rgba(255,255,255,0.42)" strokeWidth="1.4" strokeLinecap="round" />
            <line x1="6" y1="18" x2="10.5" y2="18" stroke="rgba(255,255,255,0.42)" strokeWidth="1.4" strokeLinecap="round" />
            <line x1="25.5" y1="18" x2="30" y2="18" stroke="rgba(255,255,255,0.42)" strokeWidth="1.4" strokeLinecap="round" />
          </svg>
          <div>
            <div style={{ fontFamily: "'Sora', sans-serif", fontWeight: 700, fontSize: 18, color: "#fff", letterSpacing: "-0.4px", lineHeight: 1 }}>OpraviQ</div>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9, color: "rgba(255,255,255,0.28)", letterSpacing: "1.5px", textTransform: "uppercase", marginTop: 3 }}>Intelligent ERP · v2.4</div>
          </div>
        </div>

        {[
          { label: "Payroll processed", value: "PKR 47.2M", sub: "This cycle · on time", subColor: "#34D399", bar: 88, top: "118px", right: "-36px", delay: "0s", duration: "7s" },
          { label: "Workflows active", value: "142", sub: "8 awaiting action", subColor: "#FBBF24", bar: 72, top: "270px", right: "-46px", delay: "-3.5s", duration: "9s" },
          { label: "System health", value: "99.9%", sub: "All systems nominal", subColor: "#34D399", bar: null, top: "auto", right: "-32px", delay: "-5s", duration: "8s", bottom: "88px" },
        ].map((chip, i) => (
          <div key={i} style={{
            position: "absolute", zIndex: 6,
            background: "rgba(14,17,32,0.55)",
            backdropFilter: "blur(24px)",
            WebkitBackdropFilter: "blur(24px)",
            border: "1px solid rgba(255,255,255,0.09)",
            borderRadius: 14, padding: "12px 16px",
            minWidth: 148,
            top: chip.top !== "auto" ? chip.top : undefined,
            bottom: chip.bottom,
            right: chip.right,
            animation: `chipFloat ${chip.duration} linear ${chip.delay} infinite`,
          }}>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9, color: "rgba(255,255,255,0.28)", letterSpacing: 1, textTransform: "uppercase", marginBottom: 5 }}>{chip.label}</div>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 20, fontWeight: 500, color: "#fff", lineHeight: 1, letterSpacing: "-0.5px" }}>{chip.value}</div>
            <div style={{ fontSize: 10, color: "rgba(255,255,255,0.32)", marginTop: 4, display: "flex", alignItems: "center", gap: 5 }}>
              <span style={{ width: 5, height: 5, background: chip.subColor, borderRadius: "50%", display: "inline-block", flexShrink: 0 }} />
              {chip.sub}
            </div>
            {chip.bar !== null && (
              <div style={{ height: 2, background: "rgba(255,255,255,0.06)", borderRadius: 2, marginTop: 8, overflow: "hidden" }}>
                <div style={{ height: "100%", width: `${chip.bar}%`, background: "linear-gradient(90deg,#4F6EF7,#7B5CF0)", borderRadius: 2 }} />
              </div>
            )}
          </div>
        ))}

        <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, fontWeight: 500, color: "#4F6EF7", letterSpacing: "2.5px", textTransform: "uppercase", marginBottom: 18, display: "flex", alignItems: "center", gap: 10 }}>
            Intelligence-first ERP
            <span style={{ flexShrink: 0, width: 28, height: 1, background: "linear-gradient(90deg,#4F6EF7,transparent)", display: "inline-block" }} />
          </div>
          <div style={{ fontFamily: "'Sora', sans-serif", fontWeight: 800, fontSize: 40, lineHeight: 1.08, letterSpacing: "-2px", color: "#fff", marginBottom: 20 }}>
            One brain.<br />Every module.<br />
            <span style={{ background: "linear-gradient(110deg,#4F6EF7 0%,#A78BFA 55%,#60A5FA 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>
              Your organisation.
            </span>
          </div>
          <div style={{ fontSize: 14, lineHeight: 1.75, color: "rgba(255,255,255,0.38)", maxWidth: 320, marginBottom: 36 }}>
            HR, Payroll, Recruit, Fleet, Projects, CRM and Analytics — unified, automated, and intelligent.
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8, maxWidth: 390 }}>
            {[
              { name: "People", live: true, bg: "rgba(79,110,247,0.15)", iconColor: "rgba(130,160,255,0.9)", icon: "people" },
              { name: "Payroll", live: true, bg: "rgba(52,211,153,0.12)", iconColor: "rgba(52,211,153,0.85)", icon: "payroll" },
              { name: "Recruit", live: true, bg: "rgba(251,191,36,0.12)", iconColor: "rgba(251,191,36,0.9)", icon: "recruit" },
              { name: "Fleet", live: true, bg: "rgba(248,113,113,0.1)", iconColor: "rgba(248,113,113,0.85)", icon: "fleet" },
              { name: "Projects", live: false, bg: "rgba(99,102,241,0.12)", iconColor: "rgba(150,140,255,0.8)", icon: "projects" },
              { name: "CRM", live: false, bg: "rgba(20,184,166,0.1)", iconColor: "rgba(20,184,166,0.8)", icon: "crm" },
              { name: "Analytics", live: false, bg: "rgba(236,72,153,0.1)", iconColor: "rgba(236,72,153,0.8)", icon: "analytics" },
              { name: "Finance", live: false, bg: "rgba(245,158,11,0.1)", iconColor: "rgba(245,158,11,0.8)", icon: "finance" },
            ].map(mod => (
              <div key={mod.name} style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.07)",
                borderRadius: 10, padding: "11px 10px",
                display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 7,
                cursor: "default",
              }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                  <div style={{ width: 24, height: 24, borderRadius: 6, background: mod.bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <ModuleIcon name={mod.icon} color={mod.iconColor} />
                  </div>
                  <div style={{
                    width: 5, height: 5, borderRadius: "50%", flexShrink: 0,
                    background: mod.live ? "#4F6EF7" : "rgba(255,255,255,0.15)",
                    animation: mod.live ? "dotBlink 2.2s ease-in-out infinite" : "none",
                  }} />
                </div>
                <div style={{ fontSize: 11, fontWeight: 500, color: "rgba(255,255,255,0.5)", fontFamily: "'DM Sans', sans-serif" }}>{mod.name}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9, color: "rgba(255,255,255,0.13)", letterSpacing: 1 }}>
          © 2026 OPRAVIQ · ALL RIGHTS RESERVED
        </div>
      </div>

      <div style={{
        flex: "0 0 45%", position: "relative", zIndex: 5,
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "32px 36px 32px 12px",
      }}>
        <div style={{
          width: "100%", maxWidth: 352,
          background: "#F7ECDF",
          borderRadius: 22,
          padding: "40px 36px",
          position: "relative",
          overflow: "hidden",
          boxShadow: `
            0 2px 0 rgba(255,255,255,0.7) inset,
            0 -1px 0 rgba(200,180,155,0.4) inset,
            0 32px 80px rgba(0,0,0,0.55),
            0 0 0 1px rgba(200,180,155,0.25)
          `,
        }}>

          <div style={{
            position: "absolute", inset: 0, pointerEvents: "none", zIndex: 0, borderRadius: 22,
            backgroundImage: "radial-gradient(rgba(160,130,100,0.07) 1px, transparent 1px)",
            backgroundSize: "20px 20px",
          }} />
          <div style={{
            position: "absolute", top: -40, right: -40,
            width: 180, height: 180, pointerEvents: "none",
            background: "radial-gradient(circle, rgba(79,110,247,0.07) 0%, transparent 70%)",
          }} />

          <form style={{ position: "relative", zIndex: 1 }} onSubmit={login}>

            <div style={{ marginBottom: 30 }}>
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9, fontWeight: 500, color: "rgba(79,110,247,0.65)", letterSpacing: "2px", textTransform: "uppercase", marginBottom: 8 }}>
                Workspace access
              </div>
              <div style={{ fontFamily: "'Sora', sans-serif", fontWeight: 700, fontSize: 23, color: "#1A1D27", letterSpacing: "-0.8px", marginBottom: 6, lineHeight: 1.2 }}>
                Good to see<br />you again.
              </div>
              <div style={{ fontSize: 13, color: "rgba(26,29,39,0.42)", lineHeight: 1.55 }}>
                Enter your credentials to continue
              </div>
            </div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9.5, fontWeight: 500, color: "rgba(26,29,39,0.4)", letterSpacing: "1.2px", textTransform: "uppercase", marginBottom: 7, display: "block" }}>
                Email address
              </label>
              <div style={{ position: "relative" }}>
                <div style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", display: "flex", alignItems: "center" }}>
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <rect x="1.5" y="3" width="12" height="9" rx="2" stroke="rgba(26,29,39,0.28)" strokeWidth="1.2" />
                    <path d="M1.5 5.5l6 4 6-4" stroke="rgba(26,29,39,0.28)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <input
                  value={email}
                  onChange={(e) => {setEmail(e.target.value)}}
                  type="email"
                  placeholder="you@yourcompany.com"
                  className="login-input"
                  style={{
                    width: "100%", height: 46,
                    background: "rgba(255,255,255,0.65)",
                    border: "1.5px solid rgba(26,29,39,0.1)",
                    borderRadius: 12, padding: "0 16px 0 44px",
                    fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: "#1A1D27",
                    outline: "none",
                    boxSizing: "border-box",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.04), inset 0 1px 2px rgba(0,0,0,0.03)",
                  }}
                />
              </div>
            </div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9.5, fontWeight: 500, color: "rgba(26,29,39,0.4)", letterSpacing: "1.2px", textTransform: "uppercase", marginBottom: 7, display: "block" }}>
                Password
              </label>
              <div style={{ position: "relative" }}>
                <div style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", display: "flex", alignItems: "center" }}>
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <rect x="3" y="6.5" width="9" height="7" rx="1.8" stroke="rgba(26,29,39,0.28)" strokeWidth="1.2" />
                    <path d="M5.2 6.5V4.5a2.8 2.8 0 015.6 0v2" stroke="rgba(26,29,39,0.28)" strokeWidth="1.2" strokeLinecap="round" />
                    <circle cx="7.5" cy="10" r="1" fill="rgba(26,29,39,0.3)" />
                  </svg>
                </div>
                <input
                  value={password}
                  onChange={(e) => {setPassword(e.target.value)}}
                  type="password"
                  placeholder="••••••••••"
                  className="login-input"
                  style={{
                    width: "100%", height: 46,
                    background: "rgba(255,255,255,0.65)",
                    border: "1.5px solid rgba(26,29,39,0.1)",
                    borderRadius: 12, padding: "0 16px 0 44px",
                    fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: "#1A1D27",
                    outline: "none",
                    boxSizing: "border-box",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.04), inset 0 1px 2px rgba(0,0,0,0.03)",
                  }}
                />
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 12, color: "rgba(26,29,39,0.4)", cursor: "pointer", userSelect: "none" }}>
                <input type="checkbox" style={{ accentColor: "#4F6EF7", width: 13, height: 13, cursor: "pointer" }} />
                Keep me signed in
              </label>
              <a href="#" style={{ fontSize: 12, color: "#4F6EF7", textDecoration: "none", fontWeight: 500, opacity: 0.8, fontFamily: "'DM Sans', sans-serif" }}>
                Forgot password?
              </a>
            </div>

            <button
              type="submit"
              style={{
                width: "100%", height: 48,
                background: "#1A1D27",
                border: "none", borderRadius: 12,
                fontFamily: "'Sora', sans-serif", fontWeight: 600, fontSize: 14, color: "white",
                cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center", gap: 9,
                letterSpacing: "-0.1px", marginBottom: 12,
                boxShadow: "0 4px 16px rgba(26,29,39,0.25)",
                transition: "background 0.2s, transform 0.15s",
                position: "relative", overflow: "hidden",
              }}
            >
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg, rgba(79,110,247,0) 40%, rgba(79,110,247,0.18) 100%)", pointerEvents: "none" }} />
              Continue to OpraviQ
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M2 7h10M8 3l4 4-4 4" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "4px 0 12px" }}>
              <div style={{ flex: 1, height: 1, background: "rgba(26,29,39,0.1)" }} />
              <div style={{ fontSize: 11, color: "rgba(26,29,39,0.3)", whiteSpace: "nowrap", fontFamily: "'DM Sans', sans-serif" }}>or continue with</div>
              <div style={{ flex: 1, height: 1, background: "rgba(26,29,39,0.1)" }} />
            </div>

            <button type="button" style={{
              width: "100%", height: 44,
              background: "rgba(255,255,255,0.45)",
              border: "1.5px solid rgba(26,29,39,0.1)",
              borderRadius: 12, fontFamily: "'DM Sans', sans-serif",
              fontSize: 13, color: "rgba(26,29,39,0.5)",
              cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 9,
            }}>
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                <rect x="1" y="1" width="5.5" height="5.5" rx="1.5" stroke="rgba(26,29,39,0.3)" strokeWidth="1.1" />
                <rect x="8.5" y="1" width="5.5" height="5.5" rx="1.5" stroke="rgba(26,29,39,0.3)" strokeWidth="1.1" />
                <rect x="1" y="8.5" width="5.5" height="5.5" rx="1.5" stroke="rgba(26,29,39,0.3)" strokeWidth="1.1" />
                <rect x="8.5" y="8.5" width="5.5" height="5.5" rx="1.5" stroke="#4F6EF7" strokeWidth="1.1" />
              </svg>
              Single Sign-On (SSO)
            </button>

            <div style={{ display: "flex", alignItems: "center", gap: 7, marginTop: 22, paddingTop: 18, borderTop: "1px solid rgba(26,29,39,0.08)" }}>
              <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#34D399", flexShrink: 0, animation: "dotBlink 2s ease-in-out infinite" }} />
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9.5, color: "rgba(26,29,39,0.28)", letterSpacing: "0.8px" }}>
                SECURED · OPRAVIQ.COM · 2026
              </div>
            </div>

          </form>
        </div>
      </div>

      <style>{`
        @keyframes chipFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-9px); }
        }
        @keyframes dotBlink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
        input::placeholder { color: rgba(26,29,39,0.25); font-size: 13px; }
        .login-input:focus {
          border-color: #4F6EF7 !important;
          background: rgba(255,255,255,0.9) !important;
          box-shadow: 0 0 0 3px rgba(79,110,247,0.12) !important;
        }
      `}</style>
    </div>
  );
}

function ModuleIcon({ name, color }) {
  const icons = {
    people: <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><circle cx="6.5" cy="4" r="2.2" stroke={color} strokeWidth="1.2"/><path d="M1.5 11.5c0-2.5 2.2-4 5-4s5 1.5 5 4" stroke={color} strokeWidth="1.2" strokeLinecap="round"/></svg>,
    payroll: <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1.5" y="3" width="10" height="7.5" rx="1.5" stroke={color} strokeWidth="1.2"/><path d="M4 3V2a2.5 2.5 0 015 0v1" stroke={color} strokeWidth="1.2" strokeLinecap="round"/><path d="M4.5 6.5h4M6.5 5.5v3" stroke={color} strokeWidth="1.1" strokeLinecap="round"/></svg>,
    recruit: <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 10.5L4 5l2.5 3L8.5 4l2.5 6.5" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="6.5" cy="2.5" r="1.2" fill={color}/></svg>,
    fleet: <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1" y="5" width="11" height="6.5" rx="2" stroke={color} strokeWidth="1.2"/><circle cx="3.5" cy="8" r="1" fill={color}/><circle cx="9.5" cy="8" r="1" fill={color}/><path d="M3 5V3.5a3.5 3.5 0 017 0V5" stroke={color} strokeWidth="1.2" strokeLinecap="round"/></svg>,
    projects: <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1.5" y="1.5" width="4" height="4" rx="1" stroke={color} strokeWidth="1.1"/><rect x="7.5" y="1.5" width="4" height="4" rx="1" stroke={color} strokeWidth="1.1"/><rect x="1.5" y="7.5" width="4" height="4" rx="1" stroke={color} strokeWidth="1.1"/><rect x="7.5" y="7.5" width="4" height="4" rx="1" stroke={color} strokeWidth="1.1" strokeDasharray="2 1.5"/></svg>,
    crm: <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.5 1.5C3.74 1.5 1.5 3.74 1.5 6.5S3.74 11.5 6.5 11.5 11.5 9.26 11.5 6.5" stroke={color} strokeWidth="1.2" strokeLinecap="round"/><path d="M9 1.5l1.5 1.5L9 4.5" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="6.5" cy="6.5" r="1.5" fill={color}/></svg>,
    analytics: <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 9.5L4.5 6l2 2.5L8.5 5l2 4.5" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><line x1="2" y1="11" x2="11" y2="11" stroke={color} strokeWidth="1" strokeLinecap="round"/></svg>,
    finance: <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 11V5l4.5-3.5L11 5v6" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><rect x="4.5" y="7.5" width="4" height="3.5" rx="0.8" stroke={color} strokeWidth="1.1"/></svg>,
  };
  return icons[name] ?? null;
}
